const danhSachNhomChucVu = (state) => state.nhomChucVu;
const nhomChucVuDangCapNhat = (state) => state.nhomChucVuDangCapNhat;
const nhomChucVuId = (state) => state.nhomChucVuId;

export default {
  danhSachNhomChucVu,
  nhomChucVuDangCapNhat,
  nhomChucVuId,
};
